import { useState } from "react";
import Logo from "../../../static/logo.svg";
import Button from "../../atoms/Button/Button";
import { getLoginUrl } from "../../../constants/urls";

interface NavItem {
  label: string;
  href: string;
  section: string;
}

const navItems: NavItem[] = [
  { label: "O nás", href: "#about", section: "about" },
  { label: "Benefity", href: "#benefits", section: "benefits" },
  { label: "Produkty", href: "#pricing", section: "pricing" },
  { label: "Recenzie", href: "#reviews", section: "reviews" },
  { label: "Kontakt", href: "#contact", section: "contact" },
];

const NavBar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleNavClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    item: NavItem
  ) => {
    if (item.section) {
      e.preventDefault();

      const sectionElement = document.getElementById(item.section);

      if (sectionElement) {
        sectionElement.scrollIntoView({
          behavior: "smooth",
        });
      }

      setIsMobileMenuOpen(false);
    }
  };

  const handleLogoClick = () => {
    const bannerElement = document.getElementById("banner");
    if (bannerElement) {
      bannerElement.scrollIntoView({
        behavior: "smooth",
      });

      // Update data-scroll attribute to reflect return to top
      document.documentElement.setAttribute("data-scroll", "0");
      setIsScrolled(false);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLoginClick = () => {
    window.location.href = getLoginUrl();
  };

  return (
    <div className={`dui-navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="dui-navbar-hamburger" onClick={toggleMobileMenu}>
        <div className={`hamburger-icon ${isMobileMenuOpen ? "open" : ""}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div
        className="dui-navbar-logo-mobile"
        onClick={handleLogoClick}
        style={{ cursor: "pointer" }}
      >
        <img src={Logo} alt="DoktorUI logo" />
      </div>

      <div
        className="dui-navbar-logo desktop-only"
        onClick={handleLogoClick}
        style={{ cursor: "pointer" }}
      >
        <img src={Logo} alt="DoktorUI logo" />
      </div>

      <nav
        className={`dui-navbar-nav ${isMobileMenuOpen ? "mobile-open" : ""}`}
      >
        <ul>
          {navItems.map((item) => (
            <li key={item.label}>
              <a href={item.href} onClick={(e) => handleNavClick(e, item)}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="dui-navbar-user-icon" onClick={handleLoginClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <circle cx="12" cy="8" r="4.5" />
          <path d="M12 14c-6.1 0-8 4-8 4v2h16v-2s-1.9-4-8-4z" />
        </svg>
      </div>
      <Button
        className="dui-navbar-button"
        corners="rounded"
        onClick={handleLoginClick}
      >
        Prihlásiť sa
      </Button>
    </div>
  );
};

export default NavBar;
